export default function ValueProposition() {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: 'Real-Time Updated Spreadsheets',
      description: 'Our Pandabuy spreadsheet is refreshed daily with the latest trending finds, ensuring you never miss a viral product.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Product Comparisons',
      description: 'Every item in our pandabuy sheet is quality-checked with detailed comparisons so you shop with confidence.',
    },
    {
      icon: 'ri-fire-line',
      title: 'Trending TikTok & Reddit Finds',
      description: 'We track viral pandabuy spreadsheet discoveries across social media and compile them into one easy list.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Budget to Premium Filtering',
      description: 'Whether you want affordable steals or luxury replicas, our pandabuy sheet has every price tier covered.',
    },
    {
      icon: 'ri-global-line',
      title: 'Global Shipping Insights',
      description: 'Get estimated shipping times and costs for every item so you know exactly what to expect.',
    },
    {
      icon: 'ri-star-line',
      title: 'Curated Best-of Lists',
      description: 'Handpicked top-rated pandabuy spreadsheet items organized by category, style, and popularity.',
    },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-4">
            Smart System
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.15] mb-4">
            Why Pandabuy <span className="italic">Spreadsheet</span>?
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
            Pandabuy spreadsheet collections are the fastest way to discover trending products from global suppliers.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/60 rounded-2xl p-6 hover:bg-accent-50 hover:border-accent-200 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-accent-700 text-lg`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2 leading-snug">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}